/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetListingDetailsRequest} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'
import {GetListingDetailsResponse} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'


export const getListingDetails = (request:GetListingDetailsRequest, options?: CashRequestOptions) => post<GetListingDetailsRequest, GetListingDetailsResponse>("/cash-app/business-payments/get-listing-details", request, {...options, rejectOnError: true })